import { useState, type FormEvent } from 'react'

import { api, ApiError } from '../lib/api'

export function Login({ onSuccess }: { onSuccess: () => void }) {
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(event: FormEvent) {
    event.preventDefault()
    if (busy || !password) return
    setBusy(true)
    setError(null)
    try {
      await api.login(password)
      setPassword('')
      onSuccess()
    } catch (err) {
      setError(err instanceof ApiError ? err.message : String(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="app app--login">
      <header className="app__header">
        <img src="/icon.svg" alt="" width={28} height={28} />
        <h1>AceCast</h1>
      </header>

      <form className="panel login" onSubmit={submit}>
        <label className="login__label" htmlFor="acecast-password">
          Contrasenya
        </label>
        <input
          id="acecast-password"
          className="linkform__input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          autoFocus
        />
        <button className="btn btn--primary" type="submit" disabled={busy || !password}>
          {busy ? 'Entrant…' : 'Entra'}
        </button>
        {error && <p className="panel__error">{error}</p>}
      </form>
    </div>
  )
}
